<template>
<div>
  <input type="file" ref="input" multiple accept="image/*" style="display: none"
         @input="onPictureSelected"/>

  <el-button type="secondary"  @click="take_picture"> {{ $t("inventory.addPicture") }} </el-button>
</div>
</template>

<script>


import { Connector } from '@/backendConnector';

export default {
  name: 'CameraButton',
  computed: {
    isMobile() {
      return this.$store.getters['dimensionStore/isMobile'];
    },
  },
  methods: {
    take_picture() {
      this.$refs.input.click();
    },
    onPictureSelected(e) {
      const { files } = e.target;
      for (const file of files) {
        Connector.getInstance().postPicture(file);
      }
    },
  },
};
</script>

<style scoped>

</style>
